module.exports = __webpack_public_path__ + "static/media/fileArrowDown.866dc444.svg";